import { createStore } from 'redux'

function reducer(state={ show: null }, action={args: null}) {
	return { show: action.type, args: action.args }
}

var store = createStore(reducer)

export default store;